module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "center-block loading-indicator"
  }), _vm._v(" "), (_vm.marker) ? _c('marker-details', {
    attrs: {
      "marker": _vm.marker
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marker) ? _c('marker-messages', {
    attrs: {
      "marker-id": _vm.marker.id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marker) ? _c('marker-records', {
    attrs: {
      "marker": _vm.marker
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-679346b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marker.vue
// module id = 1050
// module chunks = 1